import i18n from 'i18next'
import {addLocale, locale} from 'primereact/api'

export const SetupLanguage = (): void => {
	// Set the language for calendar depending on the active language
	const activeLanguage = i18n.language
	locale(activeLanguage)
	addLocale(activeLanguage, i18n.t('locales', {returnObjects: true}))
}